const logMiddleware = (store: any) => (next: any) => (action: any) => {
  try {
    const result = next(action)
    return result
  } catch (err) {
    throw err
  }
}

export default logMiddleware
